import React, { useEffect } from "react";
import styles from "./MessagePopup.module.css";
import PopupWrapper from "../../Layout/PopupWrapper";

const MessagePopup = ({
  logo,
  setPopup,
  backgroundColor,
  message,
  setMainPopup,
  action,
}) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <PopupWrapper>
      <div className={styles.mainDiv}>
        <div className={styles.container}>
          <img src={logo} alt="" className="w-[56px] h-[56px] mb-[24px]  " />
          {/* <p className="text-regular-medium px-[20px] mb-[16px]">
          Option to dislike is disabled
        </p> */}
          <pre className="text-small text-[#CDCDCD] px-[20px]">{message}</pre>
          <div className="seperator my-[20px]" />
          <div className="flex flex-col gap-[16px] w-[100%] cursor-pointer">
            {action ? (
              <>
                <button
                  className={`text-regular-medium ${styles.button}`}
                  onClick={action}
                  style={{
                    backgroundColor: backgroundColor,
                  }}
                >
                  Continue
                </button>
                <button
                  className={`text-regular-medium ${styles.buttonSecondary}`}
                  onClick={() => {
                    setPopup(false);
                    setMainPopup(false);
                  }}
                >
                  Cancel
                </button>
              </>
            ) : (
              <button
                className={`text-regular-medium ${styles.button}`}
                onClick={() => {
                  setPopup(false);
                  setMainPopup(false);
                }}
                style={{
                  backgroundColor: backgroundColor,
                }}
              >
                Ok
              </button>
            )}
          </div>
        </div>
      </div>
    </PopupWrapper>
  );
};

export default MessagePopup;
